import { render, staticRenderFns } from "./suggestions.vue?vue&type=template&id=0491e2c0&scoped=true"
import script from "./suggestions.vue?vue&type=script&lang=js"
export * from "./suggestions.vue?vue&type=script&lang=js"
import style0 from "./suggestions.vue?vue&type=style&index=0&id=0491e2c0&prod&lang=css"
import style1 from "./suggestions.vue?vue&type=style&index=1&id=0491e2c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0491e2c0",
  null
  
)

export default component.exports